import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";
import BboxSvg from "pages/geoscape-data/clip/clip-ui/icons/bbox.svg?react";
import CircleSvg from "pages/geoscape-data/clip/clip-ui/icons/circle.svg?react";
import PolygonSvg from "pages/geoscape-data/clip/clip-ui/icons/polygon.svg?react";
import { BoundaryDraw } from "./draw/boundary-draw";
import {
  CIRCLE_DRAW_MODE,
  POLYGON_DRAW_MODE,
  RECTANGLE_DRAW_MODE,
} from "./draw/draw-modes";

interface DrawToolbarProps {
  draw: BoundaryDraw;
  currentMode: string;
  onModeChange: (mode: string) => void;
}

const drawTools = [
  { mode: RECTANGLE_DRAW_MODE, label: "Rectangle", Icon: BboxSvg },
  { mode: POLYGON_DRAW_MODE, label: "Polygon", Icon: PolygonSvg },
  { mode: CIRCLE_DRAW_MODE, label: "Circle", Icon: CircleSvg },
] as const;

export function DrawToolbar({
  draw,
  currentMode,
  onModeChange,
}: DrawToolbarProps) {
  return (
    <div className="flex flex-row gap-2">
      {drawTools.map((tool) => {
        const isActive = currentMode === tool.mode;
        return (
          <Tooltip key={tool.mode}>
            <TooltipTrigger asChild>
              <button
                type="button"
                onClick={() => {
                  draw.changeMode(tool.mode);
                  onModeChange(tool.mode);
                }}
                aria-label={tool.label}
                aria-pressed={isActive}
                className={cn(
                  "ring-foreground/10 bg-card text-card-foreground hover:bg-accent flex size-10 items-center justify-center rounded-lg ring-1 cursor-pointer transition-colors",
                  isActive && "bg-accent",
                )}
              >
                <tool.Icon className="fill-foreground" />
              </button>
            </TooltipTrigger>
            <TooltipContent>{tool.label}</TooltipContent>
          </Tooltip>
        );
      })}
    </div>
  );
}
